import styles from "./About.module.css"
import Navbar from "../../components/Navbar/NavbarMain/Navbar";
import Footer from "../../components/Footer/Footer";
import GalleryCard from "../../components/Cards/GalleryCard/GalleryCard";
import catering from "../../assets/images/about/catering.png"
import safasTeam from "../../assets/images/about/safasTeam.png"
import rugbyTeam from "../../assets/images/about/rugbyTeam.png"
import chefs from "../../assets/images/about/chefs.png"
import burgers from "../../assets/images/about/burgers.png"
import servedFood from "../../assets/images/about/servedFood.png"
import example1 from "../../assets/images/about/example1.png"
import example2 from "../../assets/images/about/example2.png"
import example3 from "../../assets/images/about/catering.png"
import { Trans } from "react-i18next";
import { useTranslation } from "react-i18next";
import PageLayout from "../../components/Layout/PageLayout/PageLayout";
/**
* About us page.
* Contains info about the company.
* @returns TSX.Element
*/
const About = () => {
    const { t } = useTranslation(); // Translation

    return(
        <PageLayout
            pageClassName={styles.Page}
            headerClassName={styles.Header}
            headerInnerClassName={styles.Headergroup}
            contentClassName={styles.Content}
            footerClassName={styles.Footer}
            header={<Navbar />}
            footer={<Footer />}
        >
            <p className={styles.MainTitle}><Trans i18nKey="about.intro.title" components={{ 1: <span/> }} /></p>
            <p className={styles.DefaultText}>{t("about.intro.subtitle")}</p>
            <p className={styles.DefaultText}>{t("about.intro.text")}</p>
            
            <p className={`${styles.PrimaryTitle} ${styles.AlignCenter}`}>
                {t("about.what.title")}
            </p>
            <p className={styles.DefaultText}>
                <Trans i18nKey="about.what.text" components={{ 1: <span/>, 2: <br/> }} />
            </p>
            
            <div className={styles.GalleryMain}>
                <GalleryCard imgSrc={burgers} className={styles.GalleryCard}/>
                <GalleryCard imgSrc={servedFood} className={styles.GalleryCard}/>
            </div>
            
            <p className={`${styles.PrimaryTitle} ${styles.AlignCenter}`}>
                {t("about.approach.title")}
            </p>
            <p className={styles.DefaultText}>{t("about.approach.text")}</p>    




            <p className={styles.MainTitle}><Trans i18nKey="about.standards.title" components={{ 1: <span/> }} /></p>
            <div className={styles.ContentBlock}>
                <p className={styles.SecondaryTitle}>{t("about.standards.freshness.title")}</p>
                <p className={styles.DefaultText}>{t("about.standards.freshness.text")}</p>
            </div>
            <div className={styles.ContentBlock}>
                <p className={styles.SecondaryTitle}>{t("about.standards.simplicity.title")}</p>
                <p className={styles.DefaultText}>{t("about.standards.simplicity.text")}</p>
            </div>
            <div className={styles.ContentBlock}>
                <p className={styles.SecondaryTitle}>{t("about.standards.sustainability.title")}</p>
                <p className={styles.DefaultText}>{t("about.standards.sustainability.text")}</p>
            </div>


            

            <p className={styles.MainTitle}><Trans i18nKey="about.more.title" components={{ 1: <span/> }} /></p>
            <p className={styles.DefaultText}>{t("about.more.text")}</p>    


            <div className={styles.GalleryMain}>
                <GalleryCard imgSrc={example1} className={styles.GalleryCard}/>
                <GalleryCard imgSrc={example2} className={styles.GalleryCard}/>
                <GalleryCard imgSrc={example3} className={styles.GalleryCard}/>
            </div>
        </PageLayout>
    )
};

export default About;
